import { DATE_FORMAT, TIME_FORMAT } from "@constants";
import { i18n } from "@translations/i18n";
import { format } from "date-fns";

export const DATE_EXPIRY_FORMAT = "MM/yyyy";

export const formatDateTime = (dateTime: string) => {
    const dateValue = new Date(dateTime);
    const date = format(dateValue, DATE_FORMAT);
    const time = format(dateValue, TIME_FORMAT);

    return i18n.t("glossary:dateFormat", { DATE: date, TIME: time });
};

export const formatDateExpiry = (date: Date) => format(date, DATE_EXPIRY_FORMAT);

export const formatDateLong = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = new Intl.DateTimeFormat("en", { month: "long" }).format(date);
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};
